import { useRecoilValue } from 'recoil'
import unitsAtom from '@/pages/MDM/atoms/units.atom.ts'
import { IMDMUnit } from '@/pages/MDM/mdm.types.ts'

const useUnits = (): IMDMUnit[] => {
  const state = useRecoilValue(unitsAtom)

  return state.items
}

export default useUnits
